import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';

export const StyledLimitedTextWithTooltip = styled.div``;

const DEFAULT_MAX_CHARS = 50;

const LimitedTextWithTooltip = ({
  max = DEFAULT_MAX_CHARS,
  placement = 'top',
  text = ''
}) => {
  const shortText = text?.length > 0 ? `${text.substring(0, max)}...` : '';

  const isTooLong = text?.length > max;

  return (
    <StyledLimitedTextWithTooltip>
      <Tooltip
        title={text}
        disableHoverListener={!isTooLong}
        placement={placement}
        PopperProps={{
          style: { zIndex: 9999 }
        }}
      >
        <div className='text'>{isTooLong ? shortText : text}</div>
      </Tooltip>
    </StyledLimitedTextWithTooltip>
  );
};

export default LimitedTextWithTooltip;
